import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        formSubmission: '=',
        form: '=',
        category: '=',
        openedTab: '=',
        index: '=',
        counter: '=',
        categoriesCount: '=',
        disabled: '<',
        submit: '&'
    },
    template: `
        <div class="block02" ng-class="{ open:vm.openedTab === vm.index }">
            <a class="scrolltop" name="questionblock{{vm.index}}"/>
            <div class="heading01">
                <h2 ng-click="vm.setActiveTab(vm.index)">
                    <span ng-if="vm.category.activeI18n.name">{{ vm.category.activeI18n.name }}</span>
                    <small>({{ vm.answeredQuestions }}/{{ vm.category.questions.length }} {{ 'survey.questions' | translate }})</small>
                </h2>
            </div>
            <div class="question" ng-repeat="question in vm.category.questions">
                <survey-public-survey-question-checkbox
                    form="vm.form"
                    answered-questions="vm.answeredQuestions"
                    question="question"
                    counter="vm.counter[question.id]"
                    disabled="vm.disabled"
                    ng-if="question.type === vm.QUESTIONS_TYPE_ENUM.KEYS.CHECKBOX"
                />
                <survey-public-survey-question-radio
                    form="vm.form"
                    answered-questions="vm.answeredQuestions"
                    question="question"
                    counter="vm.counter[question.id]"
                    disabled="vm.disabled"
                    ng-if="question.type === vm.QUESTIONS_TYPE_ENUM.KEYS.RADIO"
                />
                <survey-public-survey-question-free-text
                    form="vm.form"
                    counter="vm.counter[question.id]"
                    answered-questions="vm.answeredQuestions"
                    question="question"
                    disabled="vm.disabled"
                    ng-if="question.type === vm.QUESTIONS_TYPE_ENUM.KEYS.FREE_TEXT"
                />
               <survey-public-survey-question-scale
                    form="vm.form"
                    counter="vm.counter[question.id]"
                    answered-questions="vm.answeredQuestions"
                    question="question"
                    disabled="vm.disabled"
                    ng-if="question.type === vm.QUESTIONS_TYPE_ENUM.KEYS.SCALE"
               />
               <survey-public-survey-question-matrix
                    form="vm.form"
                    counter="vm.counter[question.id]"
                    answered-questions="vm.answeredQuestions"
                    question="question"
                    disabled="vm.disabled"
                    ng-if="question.type === vm.QUESTIONS_TYPE_ENUM.KEYS.MATRIX"
               />
            </div>
            <ul ng-if="vm.categoriesCount !== vm.index + 1" class="actions01">
                <li><a class="btn main" ng-click="vm.setActiveTab(vm.index + 1)">{{ 'general.Next' | translate }}</a></li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($location, QUESTIONS_TYPE_ENUM) {
        this.QUESTIONS_TYPE_ENUM = QUESTIONS_TYPE_ENUM;
        this.$location = $location;
        this.answeredQuestions = 0;
    }

    setActiveTab (index) {
        this.openedTab = index;
        const target = `questionblock${index}`;
        this.$location.hash(target);
        if (!this.formSubmission.isTrial && !this.disabled) {
            this.submit({ isDraft: true });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/survey/public/survey/category/index.js